<template>
    <div :class="['td-dropzone', { dragging: isDragging }]"
         @dragover="onDragOver"
         @dragleave="onDragLeave"
         @drop="onDrop">
        <input type="file" @change="onFileChange" ref="fileInput" />
        <div class="td-banner danger slim dismissible mx-2" v-if="errorMessage">
            <icon name="faTriangleExclamation" type="solid"></icon>
            <p>{{ errorMessage }}</p>
            <icon name="faXmark" type="solid" @click="errorMessage = ''"></icon>
        </div>
        <icon name="faFileArrowUp" type="solid" class="upload-icon"></icon>
        <p class="mb-1">Drag & drop file here or <strong class="td-text-primary" @click="triggerFileSelect">click to upload</strong>.</p>
        <p class="my-0 td-text-mice td-text-subdued" v-if="isBanner">Uploaded image will be resized to 468 x 60 px.</p>
        <ul>
            <li v-if="files.length > 0" v-for="(item, index) in files" :key="item.id">
                <img v-if="item && item.preview" :src="item.preview" alt="preview" style="width: 60px; height: auto; margin-right: 10px; border-radius: 4px; object-fit: cover;" />
                {{ item.file.name }}
                <div v-if="item.status === 'pending'" class="loading-bar mx-1">
                    <div class="bar"></div>
                </div>

                <span v-if="item.status === 'success'" class="td-text-success td-badge icon-left mx-1"> <icon name="faCheck" type="solid" aria-hidden="true"></icon> Uploaded</span>
                <span v-if="item.status === 'error'" class="td-text-danger td-text-danger td-badge icon-left mx-1"> <icon name="faXmark" type="solid" aria-hidden="true"></icon> Failed</span>
                <!--<button v-if="item.status === 'success'" @click="removeFile($event, index)">Remove</button>-->
            </li>
        </ul>

    </div>
</template>

<script>
    import script from './Dropzone';
    export default script;</script>

<style lang="less">
    @import "./Dropzone.less";
</style>